var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeTab = function SvgHomeTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.832 11.186c0-2.098 0-3.147.476-4.016.476-.87 1.345-1.41 3.084-2.489l1.834-1.138c1.838-1.14 2.757-1.711 3.773-1.711 1.015 0 1.934.57 3.773 1.711l1.833 1.138c1.739 1.08 2.608 1.619 3.084 2.489.476.869.476 1.918.476 4.016v1.394c0 3.576 0 5.364-1.074 6.475-1.074 1.11-2.802 1.11-6.259 1.11H9.165c-3.457 0-5.185 0-6.259-1.11-1.074-1.111-1.074-2.9-1.074-6.475v-1.394Z",
    stroke: "currentColor",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.75v2.75",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
};
export default SvgHomeTab;